const VIDEO_PIN_COOKIE_NAME = 'video_pin_auth';
const UPLOAD_PIN_COOKIE_NAME = 'upload_pin_auth';

// Simple hash function for PIN (using built-in crypto API)
const hashPin = async (pin) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(pin + 'chs_volleyball_salt'); // Add salt for security
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

export const setPinCookie = async (pin) => {
  const pinHash = await hashPin(pin);
  const expirationDate = new Date();
  expirationDate.setHours(expirationDate.getHours() + 24);
  
  document.cookie = `${VIDEO_PIN_COOKIE_NAME}=${pinHash}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Strict`;
};

export const isPinCookieValid = async (correctPin) => {
  const cookies = document.cookie.split(';');
  const pinCookie = cookies.find(cookie => 
    cookie.trim().startsWith(`${VIDEO_PIN_COOKIE_NAME}=`)
  );
  
  if (!pinCookie) return false;
  
  const storedHash = pinCookie.split('=')[1];
  const correctHash = await hashPin(correctPin);
  
  return storedHash === correctHash;
};

export const clearPinCookie = () => {
  document.cookie = `${VIDEO_PIN_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

// ==================== UPLOAD PIN FUNCTIONS ====================

export const setUploadPinCookie = async (pin, pinUpdatedAt) => {
  const pinHash = await hashPin(pin);
  const expirationDate = new Date();
  expirationDate.setMonth(expirationDate.getMonth() + 4); // 4 months

  const cookieValue = JSON.stringify({
    hash: pinHash,
    timestamp: pinUpdatedAt || Date.now()
  });

  document.cookie = `${UPLOAD_PIN_COOKIE_NAME}=${encodeURIComponent(cookieValue)}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Strict`;
};

export const getUploadPinCookie = () => {
  const cookies = document.cookie.split(';');
  const pinCookie = cookies.find(cookie =>
    cookie.trim().startsWith(`${UPLOAD_PIN_COOKIE_NAME}=`)
  );

  if (!pinCookie) return null;

  try {
    const cookieValue = decodeURIComponent(pinCookie.split('=')[1]);
    return JSON.parse(cookieValue);
  } catch (error) {
    console.error('Error parsing upload PIN cookie:', error);
    return null;
  }
};

export const isUploadPinCookieValid = async (correctPin, pinUpdatedAt) => {
  const cookieData = getUploadPinCookie();

  if (!cookieData) return false;

  // Check if PIN has been updated since cookie was set
  if (pinUpdatedAt && cookieData.timestamp < pinUpdatedAt) {
    return false;
  }

  const correctHash = await hashPin(correctPin);
  return cookieData.hash === correctHash;
};

export const clearUploadPinCookie = () => {
  document.cookie = `${UPLOAD_PIN_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

// To manually clear PIN cache from browser console, run:
// clearPinCookie() (if imported) or:
// document.cookie = 'video_pin_auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
// clearUploadPinCookie() or:
// document.cookie = 'upload_pin_auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'